import buildQuery from 'odata-query';

import { IRequestConfig, MethodsTypes } from 'models/Axios';
import axios from 'axios';
import {
  IMissingLetters,
  IMissingLettersData,
  IFoulLetterFilterViewModel,
} from 'models/MissingLetter';
import Services from './index.service';

export default class MissingLetterServices extends Services<
  IMissingLettersData,
  IMissingLetters
> {
  /**
   * Function to get a limited qtd of items
   * @currentPage Range to skip, you need only pass currentPage (ex: currentPage = 1)
   * @pageSize Range to take, you need only pass pageSize (ex: pageSize = 15)
   */

  getByQuery = (
    currentPage?: number,
    pageSize?: number,
    orderby?: string,
    filter?: IFoulLetterFilterViewModel
  ) => {
    const skip = currentPage || 0;
    const top = pageSize || 20;
    const order = orderby ? `${orderby.split(' ')[0]}` : undefined;
    const orderDir =
      orderby && orderby.split(' ').length > 1
        ? `${orderby.split(' ')[1]}`
        : undefined;

    let _filter: IFoulLetterFilterViewModel = {};
    _filter = { ...filter };
    _filter.sortBy = order;
    _filter.sortDirection = orderDir;
    _filter.skip = skip;
    _filter.top = top;

    const filterQuery = Object.entries(_filter)
      .map((e) => e.join('='))
      .join('&');

    const config: IRequestConfig<IMissingLetters> = {
      url: `/foulLetters/Find${filterQuery ? `?${filterQuery}` : ''}`,
    };

    return this.httpRequest(config);
  };

  create = (data: any) => {
    const config: IRequestConfig<IMissingLetters> = {
      url: `${this.base_url}/foulLetters`,
      method: MethodsTypes.post,
      data,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.access_token()}`,
      },
    };
    return axios(config);
  };

  update = (data: any) => {
    const config: IRequestConfig<IMissingLetters> = {
      url: `${this.base_url}/foulLetters`,
      method: MethodsTypes.put,
      data,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.access_token()}`,
      },
    };
    return axios(config);
  };
}
